import { client } from "../gqlClient";
import { OperationVariables, TypedDocumentNode } from "@apollo/client";
import AuditLogMutation from "../components/common/AuditLogs/AuditLogMutation";
import MarkAsViewedMutation from "../components/common/MarkAsViewedMutation/MarkAsViewedMutation";
import SignOutMutation from "../components/TopMenu/SignOutMutation";

export const mutationHelper = async <TData, TVariables>(
    mutation: TypedDocumentNode<TData, TVariables>, 
    input: OperationVariables | undefined
) => {
    try {
        return await client.mutate({
            mutation: mutation,
            variables: input,
        });
    } catch {
        return undefined;
    }
};

export const auditLogHelper = (input: OperationVariables | undefined) => {
    mutationHelper(AuditLogMutation, input);
};

export const markAsViewedHelper = (input: OperationVariables | undefined) => {
    mutationHelper(MarkAsViewedMutation, input);
};

export const signOutHelper = (input: OperationVariables | undefined) => {
    mutationHelper(SignOutMutation, input);
};